import React, { useState } from "react";
import { Button, Logo, Toast } from "../../../../Components";
import { apis, post } from "../../../../Utils/axios";
import { useLoginHook } from "../../../../Hooks/useLoginHook";

function JoinTeam({ profile }) {
	const Params = new URLSearchParams(window.location.search);
	const code = Params.get("code");
	const by = Params.get("by");
	const { logout } = useLoginHook();

	const [Loader, setLoader] = useState();
	const [TeamJoined, setTeamJoined] = useState();

	const onSubmit = () => {
		setLoader(true);
		post(apis.joinTeam, { code }, (r, e) => {
			if (r) {
				setTeamJoined(true);
				setLoader();
			} else if (e) {
				Toast.handleError(e);
				setLoader();
			}
		});
	};

	if (TeamJoined) {
		return (
			<div className="justify-center w-full h-full align-center">
				<div className="w-full max-w-lg p-4 text-center">
					<img src="https://cdn.travelwings.com/assets/corp/images/football.jpg" alt="Happy dog" className="max-w-xs m-auto mb-8 rounded-full" />
					<Logo className="justify-center" />
					<div className="mt-6 text-5xl font-bold">Now a Team Player</div>
					<div className="mt-3 text-sm">Your have successfully joined {by}'s team, login to your account</div>
					<Button onClick={logout} className="m-auto mt-8">
						Sign in to your account
					</Button>
				</div>
			</div>
		);
	}

	return (
		<>
			<div className="justify-center w-full h-full align-center">
				<div className="w-full max-w-sm p-4 text-center">
					<img src="https://cdn.travelwings.com/assets/corp/images/intros/rainbow.png" alt="Rainbow" className="h-40 m-auto floating" />
					<div className="mt-6 text-5xl font-bold">Join the Team</div>
					<div className="mt-3 text-sm">You have been invited by {by} to join their company on team's plan</div>
					<div className="p-6 mt-8 border rounded-lg text-start bg-whitish">
						<h5>When you join their team, they will be able to</h5>
						<div className="flex flex-col mt-4 text-sm gap-y-1">
							<div>✅ Manage your travel bookings</div>
							<div>✅ Manage your expenses</div>
							<div>✅ Issue Reimbursements</div>
							<div>✅ Manage your account</div>
							<div>✅ Enforce policies on your account</div>
						</div>
					</div>
					<Button onClick={onSubmit} loading={Loader} className="w-full mt-6" variant="primary">
						Join the team
					</Button>
				</div>
			</div>
		</>
	);
}

export default JoinTeam;
